var SlotNames;
(function (SlotNames) {
    SlotNames["Banner"] = "Banner";
    SlotNames["EndOfArticle"] = "EndOfArticle";
})(SlotNames || (SlotNames = {}));
export { SlotNames };
